
export const F_ERR_ENUM = {
  ALL: 'all',
  PROP: 'propertyError',
  INCORRECT: 'incorrectValue',
  REQUIRED: 'valueIsRequired',
  API: 'apiResultInError'
};



// WEBPACK FOOTER //
// ./src/enum/field-error.enum.js